
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_543_9681)"}},[_c('path',{attrs:{"d":"M20.102 3.31a.314.314 0 00-.285-.2l-1.86-.044.041-1.86a.314.314 0 00-.53-.234l-2.223 2.123a.314.314 0 00-.098.22L15.1 5.3l-.55.55a8.153 8.153 0 00-5.56-2.184c-4.514 0-8.187 3.674-8.187 8.19 0 4.513 3.673 8.185 8.187 8.185 4.514 0 8.187-3.672 8.187-8.186 0-2.145-.83-4.099-2.184-5.56l.484-.484 2.1.049h.008c.08 0 .158-.031.216-.087l2.225-2.123a.313.313 0 00.076-.34zm-3.553 8.546c0 4.168-3.39 7.558-7.559 7.558-4.168 0-7.56-3.39-7.56-7.558 0-4.169 3.392-7.56 7.56-7.56 1.971 0 3.768.759 5.115 2l-1.162 1.161A5.894 5.894 0 008.99 5.938a5.924 5.924 0 00-5.916 5.918 5.923 5.923 0 005.916 5.916 5.923 5.923 0 005.918-5.916c0-1.52-.576-2.906-1.52-3.955l1.16-1.162a7.533 7.533 0 012.001 5.117zm-5.669 0c0 1.041-.848 1.889-1.89 1.889a1.892 1.892 0 01-1.89-1.89c0-1.042.849-1.89 1.89-1.89.408 0 .785.132 1.094.352l-1.316 1.316a.314.314 0 10.444.444l1.316-1.316c.22.31.352.686.352 1.094zm-.348-1.987a2.503 2.503 0 00-1.542-.531 2.52 2.52 0 00-2.517 2.517 2.52 2.52 0 002.517 2.518 2.52 2.52 0 002.518-2.518c0-.581-.2-1.116-.533-1.542l1.967-1.967a5.267 5.267 0 011.338 3.51 5.295 5.295 0 01-5.29 5.289 5.294 5.294 0 01-5.288-5.289 5.295 5.295 0 015.288-5.29c1.345 0 2.574.506 3.509 1.336L10.532 9.87zm6.93-4.639l-1.372-.032.995-.995a.314.314 0 10-.444-.443l-.898.898.029-1.198 1.018-.972.564-.539-.032 1.417a.314.314 0 00.306.32l1.416.034-1.582 1.51z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_543_9681"}},[_c('rect',{attrs:{"width":"21","height":"21","rx":"10","fill":"#fff"}})])])])
          )
        }
      }
    